<template>
	<div class="header">
		<div class="wrap">
			<router-link :to="{name: 'products'}" class="logo">
				<img src="@/assets/images/logo.png"/>
			</router-link>

			<nav class="nav">
				<a class="cart" @click="minicart">
					<div class="icon" v-html="require('@/assets/icons/shopping-cart.svg')"/>
					<div class="count" v-text="itemsCount"/>
				</a>
				<a class="search" @click="toggle('search')">
					<div class="icon" v-html="require('@/assets/icons/search-regular.svg')"/>
				</a>

				<transition name="menu" mode="out-in">
					<a class="menu" @click="toggle('menu')" :key="menuIcon">
						<div class="icon" v-html="require(`@/assets/icons/${menuIcon}.svg`)"/>
					</a>
				</transition>
			</nav>
		</div>

		<vMenu v-if="toggles.menu" @close="toggle('menu')" @logout="logout"/>
		<search v-if="toggles.search" @close="toggle('search')" @update="update"/>
	</div>
</template>

<script>
import vMenu from "./menu.vue";
import search from "./search.vue";

export default {
	components: {vMenu, search},
	props: {
		itemsCount: {type: Number, required: true},
		logout: {type: Function, required: true},
		minicart: {type: Function, required: true},
		update: {type: Function, required: true}
	},
	data() {
		return {
			toggles: {
				menu: false,
				search: false
			}
		}
	},
	computed: {
		menuIcon: (t) => t.toggles.menu ? "times-regular" : "bars-light"
	},
	methods: {
		toggle(item) {
			Object.entries(this.toggles).forEach(([key, val]) => this.toggles[key] = item === key ? !val : false);
		}
	},
	watch: {
		"$route.name"() {
			Object.entries(this.toggles).forEach(([key]) => this.toggles[key] = false);
		}
	}
};
</script>

<style lang="scss" scoped>
.header {
	z-index: 3;
	height: $headerSmall;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;

	.wrap {
		background-color: $white1;
		z-index: 122;
		position: relative;
		display: flex;
		align-items: center;
		height: 100%;
		padding: 0 em(34);
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.10000000149011612);

		.logo {
			flex-shrink: 0;

			img {
				display: block;
				width: em(100)
			}
		}

		.filter {
			margin-left: 5%;

			.box {
				box-shadow: 0 2px 4px 0 #F4F6F8;
				display: flex;

				> div {
					border: 1px solid #E1E5E7;
					display: flex;
					align-items: center;
					height: em(50);
					padding: 0 24px;
				}
			}
		}
		.nav {
			margin-left: auto;
			display: flex;
			align-items: center;

			a {
				margin-left: 32px;
				font-size: em(14);
			}

			.cart {
				user-select: none;
				position: relative;
				display: inline;

				.icon {
					/deep/ svg {
						$s: 20px;
						width: $s;
						height: $s;
					}
				}
				.count {
					position: absolute;
					top: -1em;
					right: -2em;
					font-size: 9px;
					padding: 3px 6px;
					background-color: $black1;
					border-radius: 13px;
					color: $white1;
				}
			}

			.search {
				user-select: none;
				position: relative;
				display: inline;

				.icon {
					/deep/ svg {
						$s: 20px;
						width: $s;
						height: $s;
					}
				}
			}

			.menu {
				user-select: none;
				position: relative;
				display: inline;

				&-enter-active, &-leave-active {
					transition: cubic(opacity, 0.3s / 2);
				}

				&-enter , &-leave-to {
					opacity: 0;
				}

				.icon {
					/deep/ svg {
						$s: 20px;
						width: $s;
						height: $s;
					}
				}
			}
		}
	}
}
</style>
